import { useState } from 'react';
import { SatelliteIcon } from 'assets/svgs';
import { useLocation, useNavigate } from 'react-router-dom';

const ErrorPage = () => {
  const location = useLocation();  
  const queryParams = new URLSearchParams(location.search);
  const errorCode = queryParams.get('code');
  const navigate = useNavigate();
  
    // 에러 코드에 따른 텍스트 설정
    const getErrorText = (code: string | null) => {
      switch (code) {
        case '404':
          return "The page you are looking for doesn't exist or another error occurred.";
        case '403':
          return "Forbidden. You don't have permission to access this page.";
        case '401':
          return "Unauthorized. Please log in to access this page.";
        case '500':
          return "Internal server error. Something went wrong on our end.";
        default:
          return "An unknown error occurred.";
      }
    };
  
    const errorText = getErrorText(errorCode);

  const goBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/', { replace: true }); // 히스토리가 없으면 메인 페이지로 이동
    }
  };

  return (
    <div className="flex h-screen max-h-screen w-screen bg-white items-center justify-center">
      <main className="flex w-full flex-col items-center justify-center">
        <div className="flex items-center mb-4 justify-center">
          <h1 className="text-5xl font-bold text-black">Error</h1>
          <SatelliteIcon className="h-16 w-16 object-cover mr-4" />
        </div>
        <h5 className="text-xl font-bold text-black">{errorCode}</h5>
        <p className="text-lg text-gray-700">{errorText}</p>
        <button 
          onClick={goBack} 
          className="mt-4 px-4 py-2 bg-blue-500 text-white  hover:bg-blue-700">
          ← Go Back
        </button>
      </main>
    </div>
  );
};

export default ErrorPage;